import 'front-library/dist/main.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './style.css'

import { createPinia } from 'pinia'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import i18n from './i18n'

import { configureSentry } from './config/register-sentry'
import { configureFlagsmith } from './config/register-flagsmith'
import { registerGlobalComponents } from './register-global-components'
import { installSessionIntervals } from './app/core/services/session-intervals'

// Antes de montar: los setInterval de las vistas deben quedar registrados
// para cancelarse al cerrar sesion.
installSessionIntervals()

const pinia = createPinia()
pinia.use(piniaPluginPersistedState)
const app = createApp(App)
registerGlobalComponents(app)
configureSentry(app, router)
app.use(router).use(i18n).use(pinia)
// Pinia ya esta activo: configureFlagsmith usa los stores. Fire-and-forget
// para no bloquear el mount; el store reactivo se hidrata via onChange.
configureFlagsmith()
app.mount('#app')

document.body.addEventListener('plugin_web_update_notice', e => {
  const { version, options } = e.detail
})
